window.validateEmail = function (email) {
    const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};

window.systemMsg = function (data) {
    Swal.fire({
        title: "Warning",
        html: data,
        icon: "warning",
        confirmButtonColor: "#ff9c71",
        confirmButtonText: "OK",
    });
};

window.swalMsgEach = function (data) {
    $.each(data, function (key, val) {
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            onOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
                toast.addEventListener("click", Swal.close);
            },
        });

        Toast.fire({
            icon: "error",
            title: val,
        });
    });
};

window.cAlert = function (message = "Successfully", icon = "success") {
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
        onOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
            toast.addEventListener("click", Swal.close);
        },
    });

    Toast.fire({
        icon: icon,
        title: message,
    });
};

window.swalMSg = function (data, exists = null) {
    Swal.fire({
        title: "Error",
        text: data,
        icon: "error",
        confirmButtonColor: "#c90035",
        confirmButtonText: "OK",
    });
};

$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
    try {
        unBlockEl(".modal");
        var errors = JSON.parse(jqxhr.responseText);
        var errorsText = null;
        if (errors.message[0] == "whoops") {
            localStorage.clear();
            window.location.href =
                window.location.origin + "/order/complete/" + errors.message[1];
            return;
            Swal.fire(
                "Oops...",
                "An error has occurred, please try again.",
                "error"
            );
        } else if (errors.message == "Server Error") {
            localStorage.clear();
            return;
            Swal.fire(
                "Oops...",
                "An error has occurred, please try again.",
                "error"
            );
        } else if (errors.error) {
            return Swal.fire("Oops...", errors.message, "error");
        } else {
            Object.keys(errors.errors).map(function (keyName, keyIndex) {
                if (errorsText) {
                    errorsText =
                        errorsText + "\n" + String(errors.errors[keyName]);
                } else {
                    errorsText = String(errors.errors[keyName]);
                }
            });
            Swal.fire("Oops...", errorsText, "error");
        }
    } catch (error) {
        console.log(error);
        localStorage.clear();
        return;
        Swal.fire(
            "Oops...",
            "An error has occurred, please try again.",
            "error"
        );
    }
    $("div.actions ul li")
        .last()
        .find("a")
        .html('<i class="fas fa-lock"></i> Complete Order');
    $("div.actions ul li").first().css({
        display: "block",
    });
});

window.inputInvalid = function (text = null) {
    $("#dotimepicker, #dodatepicker")
        .closest("div")
        .find("div.invalid-feedback")
        .remove();
    $("#dotimepicker, #dodatepicker").removeClass("is-invalid");
    $("#dotimepicker, #dodatepicker").addClass("is-invalid");
    $("#dotimepicker, #dodatepicker")
        .closest("div")
        .append(
            '<div class="invalid-feedback">' +
                "The restaurant is closed on the date or time you choose. " +
                " Please choose a different date or time.</div>"
        );
};

window.inputValid = function () {
    $("#dotimepicker, #dodatepicker").closest("div .invalid-feedback").remove();
    $("#dotimepicker, #dodatepicker").removeClass("is-invalid");
};

window.blockEl = function (el) {
    $(el).block({
        message:
            '<div class="spinner-grow text-primary" role="status"><span class="sr-only">Loading...</span></div>',
        overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: "wait",
        },
        css: {
            border: 0,
            padding: 0,
            backgroundColor: "transparent",
        },
    });
};

window.unBlockEl = function (el) {
    $(el).unblock();
};

window.systemMsgRed = function (icon, text, buttonText, redirect) {
    Swal.fire({
        icon: icon,
        text: text,
        confirmButtonText: buttonText,
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = redirect;
        }
    });
};

window.logout = function () {
    OneSignal.push(function () {
        OneSignal.removeExternalUserId();
    });
    event.preventDefault();
    document.getElementById("logout-form").submit();
};

var isiframe = $(".booking-step-card").closest(".isiframe").hasClass("yes");
if (isiframe) {
    var div = $(".booking-step-card")
        .parent("div")
        .removeAttr("class")
        .addClass("col");
}

   //comment
   $(".my-rating").starRating({
    starSize: 32,
    disableAfterRate: false,
    callback: function (currentRating, $el) {
        $($el)
            .closest("form")
            .find("div.hidden")
            .html(
                '<input type="hidden" name="hidden_rating" value="' +
                    currentRating +
                    '" />'
            );
    },
    onHover: function (currentIndex, currentRating, $el) {
        $(".live-rating").text(currentIndex);
    },
    onLeave: function (currentIndex, currentRating, $el) {
        $(".live-rating").text(currentRating);
    },
});

$(document).on("click", ".btn-comment-modal", function () {
    var datas = $(this).closest("form");
    var dataForm = $(datas).serialize();
    $(this).html(
        '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
    );
    $(this).closest("form").find("button").prop("disabled", true);
    $(this).closest("form").find("textarea").prop("disabled", true);
    $.ajax({
        url: window.location.origin + "/comments/add",
        method: "POST",
        data: dataForm,
        success: function (data) {
            var collapse = $(datas).closest(".collapse").attr("id");
            var coll = $("button[aria-controls=" + collapse + "]");
            $(coll).css({
                "background-color": "lightgreen",
            });
            $(datas).closest(".collapse").removeClass("show");
            setTimeout(() => {
                $(datas).closest(".collapse").remove();
                $(coll).remove();
                if (
                    $("#comment-modal #accordion").find("button").length ==
                    0
                ) {
                    $("#comment-modal").modal("hide");
                    $("a.comment-modal").closest("li").remove();
                }
                table.ajax.reload();
            }, 900);
        },
        error: function (data) {
            //console.log(data);
        },
    });
});

$(document).on("click", ".btn-list-comment", function () {
    var id = $(this).data("id");
    $("div.collapse").removeClass("show");
    $("div#" + id + "").addClass("show");
});
